module.exports = __webpack_public_path__ + "img/img4.e77a5906.jpg";